import axios from 'axios';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {
  transformZoneFromAPI,
  transformZoneToAPI
} from '../utils/zoneUtils';

export const fetchZones = (callback) => {
  return async (dispatch) => {
    dispatch({ type: 'FETCH_ZONES_REQUEST' });

    try {
      const access_token = await AsyncStorage.getItem('access_token');
      const url = await AsyncStorage.getItem('url');

      const response = await axios({
        method: 'get',
        url: `${url}/zones`,
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      });
      const transformedZones = response.data.map(transformZoneFromAPI);
      dispatch({
        type: 'FETCH_ZONES_SUCCESS',
        payload: transformedZones
      });
      if (callback) callback();
    } catch (error) {
      dispatch({
        type: 'FETCH_ZONES_FAILURE',
        payload: error?.response?.data?.error || error.message
      });
      if (callback) callback();
    }
  };
};

export const fetchZone = (zoneId) => {
  return async (dispatch) => {
    dispatch({ type: 'FETCH_ZONES_REQUEST' });

    try {
      const access_token = await AsyncStorage.getItem('access_token');
      const url = await AsyncStorage.getItem('url');

      const response = await axios({
        method: 'get',
        url: `${url}/zones/${zoneId}`,
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      });

      const transformedZone = transformZoneFromAPI(response.data);

      dispatch({
        type: 'UPDATE_ZONE_LOCAL',
        payload: transformedZone
      });
      return transformedZone;
    } catch (error) {
      dispatch({
        type: 'FETCH_ZONES_FAILURE',
        payload: error?.response?.data?.error || error.message
      });
    }
  };
};

export const addZone = (zone, callback) => {
  return async (dispatch, getState) => {
    const state = getState();
    const zoneExists = state.zone.zones.some(z => z.id === zone.id);
    if (zoneExists) {
      dispatch({
        type: 'UPDATE_ZONE_LOCAL',
        payload: zone
      });
    } else {
      dispatch({
        type: 'ADD_ZONE_LOCAL',
        payload: zone
      });
    }

    try {
      const access_token = await AsyncStorage.getItem('access_token');
      const url = await AsyncStorage.getItem('url');

      const apiData = transformZoneToAPI(zone);

      const response = await axios({
        method: 'post',
        url: `${url}/zones`,
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': 'application/json'
        },
        data: apiData
      });

      const transformedZone = transformZoneFromAPI(response.data);
      dispatch({
        type: 'REPLACE_ZONE_LOCAL',
        payload: {
          oldId: zone.id,
          newZone: transformedZone
        }
      });

      if (callback) callback(transformedZone);
      return transformedZone;
    } catch (error) {
      dispatch({
        type: 'DELETE_ZONE_LOCAL',
        payload: zone.id
      });
    }
  };
};

export const updateZone = (zoneId, updatedZone, callback) => {
  return async (dispatch) => {
    dispatch({
      type: 'UPDATE_ZONE_LOCAL',
      payload: updatedZone
    });

    try {
      const access_token = await AsyncStorage.getItem('access_token');
      const url = await AsyncStorage.getItem('url');

      const apiData = transformZoneToAPI(updatedZone);

      const response = await axios({
        method: 'patch',
        url: `${url}/zones/${zoneId}`,
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': 'application/json'
        },
        data: apiData
      });

      const transformedZone = transformZoneFromAPI(response.data);
      dispatch({
        type: 'UPDATE_ZONE_LOCAL',
        payload: transformedZone
      });

      if (callback) callback(transformedZone);
      return transformedZone;
    } catch (error) {
        dispatch(fetchZone(zoneId));
    }
  };
};

export const deleteZone = (zoneId, callback) => {
  return async (dispatch) => {
    dispatch({
      type: 'DELETE_ZONE_LOCAL',
      payload: zoneId
    });

    try {
      const access_token = await AsyncStorage.getItem('access_token');
      const url = await AsyncStorage.getItem('url');

      await axios({
        method: 'delete',
        url: `${url}/zones/${zoneId}`,
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      });

      if (callback) callback();
    } catch (error) {
        dispatch(fetchZones());
    }
  };
};

export const updateZoneDataLocal = (zone) => {
  return {
    type: 'UPDATE_ZONE_LOCAL',
    payload: zone
  };
};

export const fetchUserZoneAccesses = (username, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'FETCH_USER_ZONE_ACCESSES_REQUEST' });

    try {
      const access_token = await AsyncStorage.getItem('access_token');
      const url = await AsyncStorage.getItem('url');

      const response = await axios({
        method: 'get',
        url: `${url}/users/${username}/user_zone_accesses`,
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      });

      const data = response.data || [];
      dispatch({ type: 'FETCH_USER_ZONE_ACCESSES_SUCCESS', payload: data });
      if (callback) callback(data);
      return data;
    } catch (error) {
      dispatch({ type: 'FETCH_USER_ZONE_ACCESSES_FAILURE' });
      if (callback) callback([]);
      throw error;
    }
  };
};

export const createUserZoneAccess = (username, zoneId, accessLevel, callback) => {
  return async (dispatch) => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');

    const response = await axios({
      method: 'post',
      url: `${url}/users/${username}/user_zone_accesses`,
      headers: {
        Authorization: `Bearer ${access_token}`,
        'Content-Type': 'application/json'
      },
      data: {
        user_zone_access: {
          zone_id: zoneId,
          access_level: accessLevel
        }
      }
    });

    if (callback) callback(response.data);
    return response.data;
  };
};

export const updateUserZoneAccess = (username, accessId, accessLevel, callback) => {
  return async (dispatch) => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');

    const response = await axios({
      method: 'put',
      url: `${url}/users/${username}/user_zone_accesses/${accessId}`,
      headers: {
        Authorization: `Bearer ${access_token}`,
        'Content-Type': 'application/json'
      },
      data: {
        user_zone_access: {
          access_level: accessLevel
        }
      }
    });

    if (callback) callback(response.data);
    return response.data;
  };
};

export const updateUserZoneAccessOptional = (
  username,
  accessId,
  optionalZoneAccess,
  callback
) => {
  return async (dispatch) => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');

    const response = await axios({
      method: 'put',
      url: `${url}/users/${username}/user_zone_accesses/${accessId}`,
      headers: {
        Authorization: `Bearer ${access_token}`,
        'Content-Type': 'application/json'
      },
      data: {
        user_zone_access: {
          optional_zone_access: optionalZoneAccess
        }
      }
    });

    if (callback) callback(response.data);
    return response.data;
  };
};

// Cart Zone Access APIs
export const fetchCartZoneAccesses = (cartId, callback) => {
  return async (dispatch) => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');

    const response = await axios({
      method: 'get',
      url: `${url}/carts/${cartId}/cart_zone_accesses`,
      headers: {
        Authorization: `Bearer ${access_token}`
      }
    });

    const data = response.data || [];
    if (callback) callback(data);
    return data;
  };
};

export const createCartZoneAccess = (cartId, zoneId, accessLevel, callback) => {
  return async (dispatch) => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');

    const response = await axios({
      method: 'post',
      url: `${url}/carts/${cartId}/cart_zone_accesses`,
      headers: {
        Authorization: `Bearer ${access_token}`,
        'Content-Type': 'application/json'
      },
      data: {
        cart_zone_access: {
          zone_id: zoneId,
          access_level: accessLevel
        }
      }
    });

    if (callback) callback(response.data);
    return response.data;
  };
};

export const updateCartZoneAccess = (cartId, accessId, accessLevel, callback) => {
  return async (dispatch) => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');

    const response = await axios({
      method: 'put',
      url: `${url}/carts/${cartId}/cart_zone_accesses/${accessId}`,
      headers: {
        Authorization: `Bearer ${access_token}`,
        'Content-Type': 'application/json'
      },
      data: {
        cart_zone_access: {
          access_level: accessLevel
        }
      }
    });

    if (callback) callback(response.data);
    return response.data;
  };
};

export const updateCartZoneAccessOptional = (
  cartId,
  accessId,
  optionalZoneAccess,
  callback
) => {
  return async (dispatch) => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');

    const response = await axios({
      method: 'put',
      url: `${url}/carts/${cartId}/cart_zone_accesses/${accessId}`,
      headers: {
        Authorization: `Bearer ${access_token}`,
        'Content-Type': 'application/json'
      },
      data: {
        cart_zone_access: {
          optional_zone_access: optionalZoneAccess
        }
      }
    });

    if (callback) callback(response.data);
    return response.data;
  };
};